module.exports = __webpack_public_path__ + "static/media/5.b51f7013.jpg";